module.exports = __webpack_public_path__ + "assets/img/commission1.e9f3e5cb.svg";